module.exports = __webpack_public_path__ + "name=img/src/assets/projects/code/overhear/2.png?b83b5795ebc7ac2c7cd8741d9a721623";